import { z } from 'zod'
import { TRAINER_CONTRACT_VERSION } from './trainer-event-read'

/** Storage/upload signed-URL and long-poll contracts stay intentionally loose: handlers keep exact validation order and status branching. */
const storageObject = z.object({
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
}).passthrough()


export const trainerClientChannelAttachmentDeniedResponseSchema = storageObject
export type TrainerClientChannelAttachmentDeniedResponse = z.infer<typeof trainerClientChannelAttachmentDeniedResponseSchema>

export const trainerClientChannelAttachmentSignedDownloadResponseSchema = storageObject
export type TrainerClientChannelAttachmentSignedDownloadResponse = z.infer<typeof trainerClientChannelAttachmentSignedDownloadResponseSchema>
